import { useEffect } from 'react';
import { useTelegram } from '@/app/providers/TelegramProvider';

interface BackButtonProps {
  visible?: boolean;
  onClick?: () => void;
}

export const BackButton = ({ visible = true, onClick }: BackButtonProps) => {
  const { webApp } = useTelegram();

  useEffect(() => {
    if (!webApp) return;

    if (visible) {
      webApp.BackButton.show();
      webApp.BackButton.onClick(() => {
        onClick?.();
      });

      return () => {
        webApp.BackButton.hide();
        webApp.BackButton.offClick();
      };
    } else {
      webApp.BackButton.hide();
    }
  }, [visible, onClick, webApp]);

  return null;
};
